/**
 * Newsletter Section
 * Email signup for updates
 */

import React, { useState } from 'react';
import { usePortal } from '../../context/PortalContext';
import { Mail } from 'lucide-react';

const NewsletterSection = ({ 
  title = 'Stay Updated',
  subtitle = 'Subscribe to our newsletter for the latest news and offers'
}) => {
  const { branding } = usePortal();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('subscribing');
    // TODO: Integrate with backend newsletter API
    setTimeout(() => {
      setStatus('subscribed');
      setEmail('');
    }, 1000);
  };

  return (
    <section style={{ ...styles.section, background: branding.primaryColor }}>
      <div className="container">
        <div style={styles.content}>
          <Mail size={48} color="white" style={{ marginBottom: '20px' }} />
          <h2 style={styles.title}>{title}</h2>
          <p style={styles.subtitle}>{subtitle}</p>

          <form onSubmit={handleSubmit} style={styles.form}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              style={styles.input}
              required
            />
            <button type="submit" style={styles.button}>
              {status === 'subscribing' ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>

          {status === 'subscribed' && (
            <p style={styles.success}>Thanks for subscribing!</p>
          )}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 0',
    textAlign: 'center',
  },
  content: {
    maxWidth: '600px',
    margin: '0 auto',
  },
  title: {
    color: 'white',
    fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
    fontWeight: '700',
    marginBottom: '15px',
  },
  subtitle: {
    color: 'rgba(255,255,255,0.9)',
    fontSize: '1.1rem',
    marginBottom: '30px',
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '10px',
    maxWidth: '500px',
    margin: '0 auto',
  },
  input: {
    flex: '1 1 220px',
    padding: '15px 20px',
    border: 'none',
    borderRadius: '50px',
    fontSize: '1rem',
    outline: 'none',
  },
  button: {
    flex: '0 1 auto',
    padding: '15px 30px',
    background: '#1a1a2e',
    color: 'white',
    border: 'none',
    borderRadius: '50px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'opacity 0.3s',
  },
  success: {
    color: 'white',
    marginTop: '15px',
    fontWeight: '500',
  },
};

export default NewsletterSection;
